<template>
  <div class="err-container">
    <img src="../../assets/image/500.png" alt />
    <div class="info-text">抱歉，服务器出错了</div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.err-container {
  width: 100%;
  height: 85vh;
  padding-top: 200px;
}
img {
  display: block;
  width: 311px;
  height: 165px;
  margin: 0 auto;
}
.info-text {
  font-size: 16px;
  color: rgba(102, 102, 102, 1);
  line-height: 22px;
  text-align: center;
  margin-top: 24px;
}
</style>
